{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "platform-base",
  "features": [
    {
      "id": "identity-access",
      "name": "Identity & Access",
      "summary": "Users, authentication, SSO, and organizational boundaries.",
      "availability": "AVAILABLE"
    },
    {
      "id": "authority-governance",
      "name": "Authority & Governance",
      "summary": "Roles, credentials, accountability, and oversight.",
      "availability": "AVAILABLE"
    },
    {
      "id": "data-governance",
      "name": "Data Governance",
      "summary": "Tenant isolation, sharing controls, retention, and source-of-truth authority.",
      "availability": "AVAILABLE"
    },
    {
      "id": "workflow-services",
      "name": "Workflow Services",
      "summary": "Tasks, notifications, and approvals.",
      "availability": "AVAILABLE"
    },
    {
      "id": "evidence-services",
      "name": "Evidence Services",
      "summary": "Documents, media, and supporting materials with provenance.",
      "availability": "AVAILABLE"
    },
    {
      "id": "integration-services",
      "name": "Integration Services",
      "summary": "Connectors, APIs, and event feeds.",
      "availability": "AVAILABLE"
    },
    {
      "id": "tenant-organization",
      "name": "Tenant & Organization",
      "summary": "Locations, aircraft, teams, and context.",
      "availability": "AVAILABLE"
    }
  ]
}